export const CREATE_USER = 'user/createUser';
export const GET_USERS_LIST = 'user/getUsersList';
export const UPDATE_USER = 'user/updateUser';
export const DELETE_USER = 'user/deleteUser';
export const SEARCH_USER = 'user/getSearchUserList';
export const SET_AUTHENTICATED_USER = 'user/setAuthenticatedUser';
export const BULK_CREATE_USER = 'user/bulkCreateUser';
export const RECOVER_USER = 'user/recoverUser';
